






















import Vue from 'vue'
import CoreBase from '@corets/base'
import Base from '@custom/base'
import {mapGetters} from 'vuex'
import NCommonTitle from '@corecp/NCommonTitle.vue'
import NMultiSelect from '@corecp/NMultiSelect.vue'
import {PagingInfo} from '@corets/type';

export default Vue.extend({
    name: 'HomePage',
    mixins: [CoreBase, Base],
    components: {
        NCommonTitle,
        NMultiSelect
    },
    computed: {
        ...mapGetters([
            'cacheEntry',
            'userInfo'
        ])
    },
    methods: {
        toPage (page: any) {
            const self = this as any
            self.$newpage({
                title: page.title,
                component: page.path
            })
        }
    },
    data () {
        return {
        }
    }
})
